
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "editing-page-styles",
  "title": "Editing Page Styles in Tradly",
  "sidebar_label": "Editing Page Styles"
};
const slug = 'editing-page-styles';
const tableOfContents = [{
  "title": "Editing Page Styles in Tradly",
  "slug": "editing-page-styles-in-tradly",
  "children": [{
    "title": "Working on the Home Page",
    "slug": "working-on-the-home-page",
    "children": [{
      "title": "1. Accessing the Home Page",
      "slug": "1-accessing-the-home-page"
    }, {
      "title": "2. Previewing Changes",
      "slug": "2-previewing-changes"
    }, {
      "title": "3. Adding and Editing Blocks",
      "slug": "3-adding-and-editing-blocks"
    }]
  }, {
    "title": "Tips for Effective Template Creation",
    "slug": "tips-for-effective-template-creation",
    "children": []
  }, {
    "title": "Conclusion",
    "slug": "conclusion",
    "children": []
  }]
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <_Heading level={2} id={"editing-page-styles-in-tradly"} nextElement={{
      "type": "paragraph"
    }}>Editing Page Styles in Tradly</_Heading>
    <p>{`This guide outlines the process for editing a page to update its styles, following a structured approach similar to a Figma design file. The work can be divided into the following categories:`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol"><strong parentName="li">{`Common Blocks`}</strong>{`: Header, footer, listing card, account card, etc.`}</li>
      <li parentName="ol"><strong parentName="li">{`Page-wise`}</strong>{`: Home page, listing page, listing details page, etc.`}</li>
      <li parentName="ol"><strong parentName="li">{`Responsive Design`}</strong>{`: Design first for web, then for mobile.`}</li>
    </ol>
    <_Heading level={3} id={"working-on-the-home-page"} nextElement={{
      "type": "paragraph"
    }}>Working on the Home Page</_Heading>
    <p>{`Here is a step-by-step process for working on the home page:`}</p>
    <_Heading level={4} id={"1-accessing-the-home-page"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>1. Accessing the Home Page</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Navigate to the home page within the Tradly Editor.`}</li>
      <li parentName="ul">{`If the design specifies a single-column row, select the single column and save it. Note that every save is in draft mode, meaning it will not publish to production immediately.`}</li>
    </ul>
    <_Heading level={4} id={"2-previewing-changes"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>2. Previewing Changes</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Use the preview panel to view changes based on the edits.`}</li>
      <li parentName="ul">{`To modify page styles, click on the settings icon at the end of the Home page title line.`}</li>
      <li parentName="ul">{`Set up the home page background color, padding, max width, and max height according to the design specifications.`}</li>
    </ul>
    <_Heading level={4} id={"3-adding-and-editing-blocks"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>3. Adding and Editing Blocks</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`After saving, add new blocks from the block list.`}</li>
      <li parentName="ul">{`Update the row or column design and add block designs based on the layout.`}</li>
    </ul>
    <p>{`This approach facilitates the creation and customization of templates.`}</p>
    <_Heading level={3} id={"tips-for-effective-template-creation"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Tips for Effective Template Creation</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><strong parentName="li">{`Divide Work into Small Portions`}</strong>{`: If the home page contains 10 blocks, divide the task into 10 smaller tasks and work on each one individually.`}</li>
      <li parentName="ul"><strong parentName="li">{`Publish Incrementally`}</strong>{`: After completing each task, publish it to production. This practice allows the use of the history feature to revert to previous versions if needed.`}</li>
      <li parentName="ul"><strong parentName="li">{`Start with Defaults`}</strong>{`: For each page or block, start with default blocks or values. Enhance these elements afterward to get a clear understanding of the structure.`}</li>
    </ul>
    <_Heading level={3} id={"conclusion"} nextElement={{
      "type": "paragraph"
    }}>Conclusion</_Heading>
    <p>{`Editing page styles in Tradly involves careful planning and incremental updates. Dividing the work, using the preview and history features, and starting with default setups enables efficient creation and customization of the website to match design specifications.`}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
